import { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

// * Main Wrapper for the hero banner
export const AdventCalendarVariationsWrapperStyles = css`
  &.animated-fanned-cards-multi-product-holiday {
    display: flex;
    align-items: center;
    flex-direction: column;
    position: relative;
    padding-bottom: 70px;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      background-color: ${themeGet('colors.velvet')};
      flex-direction: row;
      align-items: stretch;
      padding-bottom: 0px;
    }
  }

  &.hero-holiday-gradient {
    display: flex;
    align-items: center;
    flex-direction: column;
    position: relative;
    padding-bottom: 70px;

    &:after {
      content: '';
      display: block;
      width: 100%;
      height: 25%;
      background-color: ${themeGet('colors.light-grey')};
      position: absolute;
      bottom: 0;
      left: 0;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      background-color: ${themeGet('colors.velvet')};
      flex-direction: row;
      align-items: stretch;
      padding-bottom: 0px;

      &:after {
        height: 25%;
      }
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      &:after {
        height: 20%;
      }
    }
  }
`;

// * Styling for the Div that wraps all the text copy
export const AdventCalendarVariationsContentStyles = css`
  ${AdventCalendarVariationsWrapperStyles}.animated-fanned-cards-multi-product-holiday & {
    background-color: ${themeGet('colors.velvet')};
    padding: 55px 20px 50px;
    position: static;
    width: 100%;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      position: relative;
      width: 50%;
      padding: 100px 25px 70px;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      padding: 130px 35px 80px;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    }
  }

  ${AdventCalendarVariationsWrapperStyles}.hero-holiday-gradient & {
    background-color: ${themeGet('colors.velvet')};
    padding: 30px 20px;
    position: static;
    width: 100%;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      position: relative;
      width: 50%;
      padding: 60px 20px 0;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      padding: 80px 30px 0;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      padding: 100px 35px 0;
    }
  }
`;

// * Styling for the heading inside the content box
export const AdventCalendarVariationsTitleStyles = css`
  ${AdventCalendarVariationsWrapperStyles}.animated-fanned-cards-multi-product-holiday & {
    color: ${themeGet('colors.white')};
    font-family: ${themeGet('fonts.noir')};
    font-size: 30px;
    font-weight: ${themeGet('fontWeights.bold')};
    letter-spacing: 0;
    line-height: 26.4px;

    span {
      display: inline-block;
      margin: 20px 0;

      color: inherit;
      font-family: inherit;
      font-size: 56px;
      font-weight: ${themeGet('fontWeights.bold')};
      letter-spacing: 0;
      line-height: 39.24px;
    }

    .pts-bubble {
      height: 26px;
      width: 36px;
      margin: 0;
    }
  }

  ${AdventCalendarVariationsWrapperStyles}.hero-holiday-gradient & {
    color: ${themeGet('colors.white')};
    font-size: 21px;
    font-weight: ${themeGet('fontWeights.bold')};
    letter-spacing: 0;
    line-height: 26.27px;

    span {
      display: inline-block;
      color: inherit;
      font-family: inherit;
      font-size: 57px;
      font-weight: ${themeGet('fontWeights.bold')};
      letter-spacing: 0;
      line-height: 41.67px;
      margin: 10px 0 20px;

      &:lang(fr) {
        margin: 15px 0;
      }
    }

    .pts-bubble {
      height: 26px;
      width: 36px;
      margin: 0;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
    ${AdventCalendarVariationsWrapperStyles}.animated-fanned-cards-multi-product-holiday & {
      span {
        font-size: 63px;
      }
    }

    ${AdventCalendarVariationsWrapperStyles}.hero-holiday-gradient & {
      span {
        font-size: 64px;
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    ${AdventCalendarVariationsWrapperStyles}.animated-fanned-cards-multi-product-holiday & {
      span {
        font-size: 72px;
      }
    }

    ${AdventCalendarVariationsWrapperStyles}.hero-holiday-gradient & {
      font-size: 24px;
      font-weight: ${themeGet('fontWeights.bold')};
      letter-spacing: 0;
      line-height: 32px;

      span {
        font-size: 72px;
        letter-spacing: 0;
        line-height: 41.67px;
        margin: 20px 0;

        &:lang(fr) {
          margin: 20px 0;
        }
      }

      .pts-bubble {
        height: 44px;
        width: 46px;
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    ${AdventCalendarVariationsWrapperStyles}.animated-fanned-cards-multi-product-holiday & {
      font-size: 30px;
      font-weight: ${themeGet('fontWeights.medium')};
      letter-spacing: 0;
      line-height: 45px;

      span {
        font-size: 95px;
        font-weight: ${themeGet('fontWeights.medium')};
        letter-spacing: 0;
        line-height: 57px;
      }

      .pts-bubble {
        height: 37px;
        width: 52px;
      }
    }

    ${AdventCalendarVariationsWrapperStyles}.hero-holiday-gradient & {
      font-size: 24px;
      font-weight: ${themeGet('fontWeights.bold')};
      letter-spacing: 0;
      line-height: 32px;

      span {
        font-size: 95px;
        font-weight: ${themeGet('fontWeights.bold')};
        letter-spacing: 0;
        line-height: 50px;
        margin: 20px 0 30px;

        &:lang(fr) {
          margin: 20px 0;
        }
      }

      .pts-bubble {
        height: 37px;
        width: 52px;
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    ${AdventCalendarVariationsWrapperStyles}.animated-fanned-cards-multi-product-holiday & {
      font-size: 50px;
      font-weight: ${themeGet('fontWeights.medium')};
      letter-spacing: 0;
      line-height: 45px;

      span {
        font-size: 120px;
        font-weight: ${themeGet('fontWeights.medium')};
        letter-spacing: 0;
        line-height: 67.57px;
        margin: 35px 0 20px;
      }

      .pts-bubble {
        height: 61px;
        width: 70px;
      }
    }

    ${AdventCalendarVariationsWrapperStyles}.hero-holiday-gradient & {
      font-size: 32px;
      font-weight: ${themeGet('fontWeights.bold')};
      letter-spacing: 0;
      line-height: 35.91px;

      span {
        font-size: 132.72px;
        font-weight: ${themeGet('fontWeights.bold')};
        letter-spacing: 0;
        line-height: 72.34px;
        margin: 30px 0 40px;

        &:lang(fr) {
          margin: 30px 0;
        }
      }

      .pts-bubble {
        height: 61px;
        width: 70px;
      }
    }
  }
`;

// * Intro body copy below the heading in the hero
export const AdventCalendarVariationsIntroStyles = css`
  ${AdventCalendarVariationsWrapperStyles}.animated-fanned-cards-multi-product-holiday & {
    margin: 15px 0 0;

    p {
      color: ${themeGet('colors.white')};
    }
  }

  ${AdventCalendarVariationsWrapperStyles}.hero-holiday-gradient & {
    margin: 15px 0 0;

    p {
      color: ${themeGet('colors.white')};
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    ${AdventCalendarVariationsWrapperStyles}.animated-fanned-cards-multi-product-holiday & {
      margin: 35px 0 0;
      max-width: 415px;
    }

    ${AdventCalendarVariationsWrapperStyles}.hero-holiday-gradient & {
      margin: 35px 0 0;
      max-width: 415px;
    }
  }
`;

// * The Div that wraps the CTA in the Hero
export const AdventCalendarVariationsCTAWrapperStyles = css`
  ${AdventCalendarVariationsWrapperStyles}.animated-fanned-cards-multi-product-holiday & {
    display: flex;
    flex-direction: row;
    text-align: center;
    padding: 0;
    margin: 0 auto;
    justify-content: center;

    position: absolute;
    left: 0;
    bottom: 0;

    a {
      min-width: 200px;

      @media only screen and (min-width: 340px) {
        min-width: 250px;
      }
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin: 0;
      position: static;
      left: auto;
      bottom: auto;
      padding: 2rem 0 0;
      justify-content: flex-start;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      padding: 50px 0 0;
      justify-content: flex-start;
    }
  }

  ${AdventCalendarVariationsWrapperStyles}.hero-holiday-gradient & {
    display: flex;
    flex-direction: row;
    text-align: center;
    padding: 0;
    margin: 0 auto;
    justify-content: center;

    position: absolute;
    z-index: 1;
    left: 0;
    bottom: 0;

    a {
      min-width: 200px;

      @media only screen and (min-width: 340px) {
        min-width: 250px;
      }
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin: 0;
      left: auto;
      bottom: auto;
      padding: 100px 0 0;
      justify-content: flex-start;

      position: relative;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      padding: 120px 0 0;
      justify-content: flex-start;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      padding: 140px 0 0;
    }
  }
`;

// * The Div that wraps the Images in the hero
export const AdventCalendarVariationsMediaContainerStyles = css`
  ${AdventCalendarVariationsWrapperStyles}.animated-fanned-cards-multi-product-holiday & {
    position: static;
    width: 50%;
    margin: 0;
    background-color: #9a221d;
    padding: 0;
  }

  ${AdventCalendarVariationsWrapperStyles}.hero-holiday-gradient & {
    position: static;
    width: 50%;
    margin: 0;
    background-color: #9a221d;
    padding: 0;
  }
`;

// * The styling for images in the hero
export const AdventCalendarVariationsHeroImageStyles = css``;
